import { ConnectProto } from "@racoon/api";

/** RouteCreate fields for a new, empty trip on a shift that departs and unloads where `like` does. */
export const tripLike = (
  like: ConnectProto.Route,
  driverOnShiftId: bigint,
  ownerOrganizationId: bigint,
) => ({
  ownerOrganizationId,
  driverOnShiftId,
  sourceLon: like.sourceLon ?? 0,
  sourceLat: like.sourceLat ?? 0,
  // The backend takes a destination whole or not at all: coordinates without the
  // location id are refused, so a trip that unloads nowhere sends neither.
  ...(like.destinationLocationId
    ? {
        destinationLocationId: BigInt(like.destinationLocationId),
        destinationLon: like.destinationLon ?? 0,
        destinationLat: like.destinationLat ?? 0,
      }
    : {}),
  sourceLocationId: like.sourceLocationId ? BigInt(like.sourceLocationId) : undefined,
  routeCategory: like.routeCategory,
});
